import { render, staticRenderFns } from "./ChatJoined.vue?vue&type=template&id=434a222a&scoped=true"
import script from "./ChatJoined.vue?vue&type=script&lang=js"
export * from "./ChatJoined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434a222a",
  null
  
)

export default component.exports